import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject, of, Subject, switchMap } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { DxCheckBoxModule } from 'devextreme-angular';
import { NgIf, AsyncPipe } from '@angular/common';
import { cameFromClick, showErrorSwal } from '@asamco/utils';
import { WarningModalMessage } from '../interfaces/warning-modal-message.interface';
import { WarningModalMessageService } from '../services/warning-modal-message.service';

@Component({
    selector: 'message-modal',
    templateUrl: 'messagemodal.component.html',
    styleUrls: ['messagemodal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: true,
    imports: [
        NgIf,
        DxCheckBoxModule,
        FormsModule,
        AsyncPipe,
    ],
})
export class MessageModalComponent {
	@Input()
	ls;

	public modalMessageId: number;

	public messageHtml: string;

	visible$ = new BehaviorSubject<boolean>(false);
	keepshowing$ = new BehaviorSubject<boolean>(true);

	height$ = new BehaviorSubject<string>('400px');
	width$ = new BehaviorSubject<string>('400px');

	done$: Subject<boolean>;

	constructor(private warningModalMessageService: WarningModalMessageService) {

	}

	onKeepShowingChanged(e) {
		if (cameFromClick(e) && this.ls) {
			this.warningModalMessageService.setKeepShowing(this.ls.cc.linkID, this.modalMessageId, !e.value).subscribe({
				error: err => showErrorSwal(err.text(), { title: `Failed to update message visibility.` })
			});
		}
	}

	hide(): void {
		this.visible$.next(false);
		this.done$.next(true);
	}

	showForModalMessages(messages: WarningModalMessage[], contextMap?: Record<string, string>) {
		var chain = of(true);
		for(const message of messages) {
			chain = chain.pipe(switchMap(() => this.showForModalMessage(message, contextMap)));
		}
		return chain;
	}

	showForModalMessage(message: WarningModalMessage, contextMap?: Record<string, string>) {
		this.messageHtml = message.messageHtml;
		if(this.ls) this.messageHtml = this.replaceForMap(this.messageHtml, 'source', this.ls.source.translations);
		if(this.ls) this.messageHtml = this.replaceForMap(this.messageHtml, 'target', this.ls.target.translations);
		if(contextMap) this.messageHtml = this.replaceForMap(this.messageHtml, 'context', contextMap);

		this.modalMessageId = message.id;
		this.height$.next(message.height);
		this.width$.next(message.width);
		this.keepshowing$.next(true);

		this.done$ = new Subject<boolean>();

		this.visible$.next(true);

		return this.done$;
	}

	replaceForMap(input: string, tag: string, mapObject: Record<string, string>) {
		const regex = new RegExp(`\{\{(${Object.keys(mapObject).map(key => `${tag}.${key}(:U)?`).join('|')})\}\}`, 'g');
		return input.replace(regex, (match) => {
			var matched = match.substring(2, match.length - 2).split(':');
			const translated = mapObject[matched[0].split('.')[1]];
			if(matched[1] !== 'U') {
				return translated.toLowerCase();
			}
			return translated;
		});
	}

	public ok() {
		this.hide();
	}
}
